export default "__VITE_ASSET__6aeb4cb9__"